export enum SessionBreakdownType {
  PRACTICE = 0,
  GAMEDAY_TOTAL = 1,
  GAMEDAY_FIRST_HALF = 2,
  GAMEDAY_SECOND_HALF = 3
} 